"use client";

import Image from "next/image";
import ScrollReveal from "@/components/common/ScrollReveal";
import { Location } from "@/types/constants_type";

interface BusinessHoursProps {
  location: Location;
}

/** Left-side "Business Hours" panel used on every country contact page. */
export default function BusinessHours({ location }: BusinessHoursProps) {
  return (
    <div className="flex flex-col gap-12">
      <div className="flex flex-col gap-6">
        <ScrollReveal direction="up" delay={0}>
          <h2 className="text-white font-bold text-[40px] md:text-[48px] lg:text-[55px] leading-[56px] md:leading-[68px] lg:leading-[79px] tracking-[0px]">
            Business Hours
          </h2>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={100}>
          <div className="flex items-start gap-6 sm:gap-[64px] group">
            <div className="w-[50px] h-[50px] flex-shrink-0 transition-transform duration-300 group-hover:scale-110">
              <Image
                src="/images/Contact/location.svg"
                alt="Location"
                width={50}
                height={50}
                className="w-full h-full"
              />
            </div>
            {/* Supporting-copy ladder (same as the product pages). Lines that are
                already on a 24px leading keep it — the ladder's mobile step is
                24px too, so only the size steps down. */}
            <div className="space-y-2">
              <p className="text-white font-semibold text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] tracking-[0.5px] transition-colors duration-300 group-hover:text-primary">
                {location.company}
              </p>
              <p className="text-[#D6D6D6] font-normal text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[28px] tracking-[0.5px]">
                {location.address}
              </p>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={150}>
          <div className="flex items-center gap-6 sm:gap-[64px] group">
            <div className="w-[50px] h-[50px] flex-shrink-0 transition-transform duration-300 group-hover:scale-110">
              <Image
                src="/images/Contact/phone.svg"
                alt="Phone"
                width={50}
                height={50}
                className="w-full h-full"
              />
            </div>
            <a
              href={`tel:${location.phoneNumber}`}
              className="text-white font-semibold text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] tracking-[0.5px] hover:text-primary transition-colors"
            >
              {location.phone}
            </a>
          </div>
        </ScrollReveal>
      </div>

      <ScrollReveal direction="up" delay={200}>
        <div className="space-y-2 pt-12 border-[#9EA5AC] border-t-[1.5px] border-x-0 border-b-0">
          <p className="text-white opacity-80 font-normal text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[28px] tracking-[0.5px]">
            We can meet you by appointment
          </p>
          <p className="text-primary-600 font-semibold text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] tracking-[0.5px]">
            Monday to Friday (9:00 to 18:00)
          </p>
        </div>
      </ScrollReveal>
    </div>
  );
}
